/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export default class GraphQLSimplifier {
    public static simplify(data: any) {
        if (!data) {
            return undefined;
        }

        const keysLevel1 = Object.keys(data);
        if (!keysLevel1) {
            return undefined;
        }

        return data[keysLevel1[0]];
    }
}
